module.exports = __webpack_public_path__ + "static/media/topFilter.418f2b0d.svg";